// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"git-commit-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","cx":10.5,"cy":18,"r":3,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M19 11.0001L10.5 8.50017L12.4971 3.99365L4.5 10.0001L11.5 13.0002L9.20879 15.2913C9.59986 15.1046 10.0377 15 10.5 15C12.145 15 13.4807 16.324 13.4998 17.9644L14 18.0002L19 11.0001Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14 18.0002L19 11.0001L10.5 8.50017L12.4971 3.99365L4.5 10.0001L11.5 13.0002L9.99999 14.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13.5 18C13.5 19.6569 12.1569 21 10.5 21C8.84315 21 7.5 19.6569 7.5 18C7.5 16.3431 8.84315 15 10.5 15C12.1569 15 13.5 16.3431 13.5 18Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-git-commit-1')
export default class GitCommit1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'git-commit-1',
    }
  }
}
